import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { generalClient } from '../../../../utils/apollo/api'
import { useMasks } from '../_load/MasksLoader'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ListCounter from '../../../../components/helpers/ListCounter'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'
import { useMaskActionsList } from '../../_actions/maskActions'

const MaskTable = () => {
  const { t } = useTranslation('listMasks')

  const data = useMasks()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter
            client={generalClient}
            entity="Mask"
            filterName="MaskFilter "
            filters={{ includeDisabled: true }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 2
    },
    {
      label: t('pattern'),
      dataIndex: 'pattern',
      sortIndex: false,
      flex: 4
    },
    {
      label: t('enabled'),
      dataIndex: 'enabled',
      sortIndex: false,
      width: 4,
      render: (_, record) => <SwitchDisabled client={generalClient} entity="Mask" record={record} size={'small'} />
    },
    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useMaskActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" inPanel data={data} />
}

export default MaskTable
